import { AppealConstants } from './appeal.constants';
import { AppealInterface, AppealResponseInterfaceAll, AppealResponseInterfaceSingle, ReducerActionInterface } from '../../interfaces';

// ============ INTERFACE ============

export interface AppealStateInterface {
  revision: number;
  currentAppeal?: AppealInterface;
  appeals?: AppealResponseInterfaceAll;
  error?: string;
  isLoading?: boolean;
}

// ============ INIT STATE ============

const initialState: AppealStateInterface = {
  revision: 0,
  currentAppeal: undefined,
  appeals: {
    data: [],
    meta: {
      totalResourceCount: 0
    }
  }
}

// ============ REDUCERS ============

const setLoader = (state: AppealStateInterface, payload: boolean): AppealStateInterface => {
  return {
    ...state,
    isLoading: payload,
  };
};

const getSingleSuccess = (state: AppealStateInterface, payload: AppealResponseInterfaceSingle): AppealStateInterface => {
  return {
    ...state,
    isLoading: false,
    currentAppeal: payload.data,
  };
};

const getAllSuccess = (state: AppealStateInterface, payload: AppealResponseInterfaceAll): AppealStateInterface => {
  return {
    ...state,
    isLoading: false,
    appeals: {
      data: payload.data,
      meta: payload.meta
    }
  };
};

const createSuccess = (state: AppealStateInterface, payload: AppealResponseInterfaceSingle): AppealStateInterface => {
  return {
    ...state,
    revision: state.revision + 1,
    isLoading: false,
    currentAppeal: payload.data,
  };
};

const updateSuccess = (state: AppealStateInterface, payload: AppealResponseInterfaceSingle): AppealStateInterface => {
  return {
    ...state,
    revision: state.revision + 1,
    isLoading: false,
    currentAppeal: payload.data,
  };
};

const clearCurrent = (state: AppealStateInterface): AppealStateInterface => {
  return {
    ...state,
    revision: state.revision + 1,
    isLoading: false,
    currentAppeal: undefined,
  };
};

const clearList = (state: AppealStateInterface): AppealStateInterface => {
  return {
    ...state,
    revision: state.revision + 1,
    isLoading: false,
    appeals: {
      data: [],
      meta: {
        totalResourceCount: 0
      }
    }
  };
};

const deleteSuccess = (state: AppealStateInterface): AppealStateInterface => {
  return {
    ...state,
    revision: state.revision + 1,
    isLoading: false,
    currentAppeal: undefined,
  };
};

const error = (state: AppealStateInterface, payload: string) => {
  return {
    ...state,
    revision: state.revision + 1,
    isLoading: false,
    error: payload,
  };
};

// ============ EXPORTS ============

export const AppealReducer = (state = initialState, action: ReducerActionInterface) => {
  switch (action.type) {
    case AppealConstants.SET_LOADER:
      return setLoader(state, action.payload);
    case AppealConstants.GET_SINGLE_SUCCESS:
      return getSingleSuccess(state, action.payload);
    case AppealConstants.GET_ALL_SUCCESS:
      return getAllSuccess(state, action.payload);
    case AppealConstants.CREATE_SUCCESS:
      return createSuccess(state, action.payload);
    case AppealConstants.UPDATE_SUCCESS:
      return updateSuccess(state, action.payload);
    case AppealConstants.CLEAR_CURRENT:
      return clearCurrent(state);
    case AppealConstants.CLEAR_LIST:
      return clearList(state);
    case AppealConstants.DELETE:
      return deleteSuccess(state);
    case AppealConstants.ERROR:
      return error(state, action.payload);
    default:
      return state;
  }
};
